import React from "react";
import { Skeleton } from "@mui/material";

export function NotificationListSkeleton({ rows = 3 }) {
  return (
    <div className="flex flex-col gap-2" data-testid="notification-skeleton">
      <Skeleton data-testid="notification-list-skeleton-header" variant="text" width={80} />
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton
          key={index}
          data-testid="notification-list-skeleton-row"
          variant="rounded"
          width="100%"
          height={60}
        />
      ))}
    </div>
  );
}
